import { type PropsWithChildren, useState } from 'react';

import { Check, Copy, X } from 'lucide-react';

import { Button, type Props as ButtonProps } from '../shadcn/button';

type Props = PropsWithChildren<{
  text: string;
  disabled?: boolean;
  onCopy?: () => void;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
}>;

export default function CopyButton({
  text,
  disabled,
  onCopy,
  variant = 'ghost',
  size = 'icon-xxs',
  children,
}: Props) {
  const [copyStatus, setCopyStatus] = useState<
    'success' | 'failed' | undefined
  >();

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopyStatus('success');
      onCopy?.();
    } catch {
      setCopyStatus('failed');
    }

    setTimeout(() => setCopyStatus(undefined), 5000);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      disabled={disabled || copyStatus !== undefined}
    >
      {copyStatus === undefined && <Copy className="size-3" />}
      {copyStatus === 'success' && <Check className="size-3" />}
      {copyStatus === 'failed' && <X className="size-3" />}

      {children}
    </Button>
  );
}
